module.exports = __webpack_public_path__ + "media/images/422x333_shadow-305a6d3112c06e80d55e7a6f3658525ffe2da26b5f8857a9faabc346d053db55.png";